import React, {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import {ToastContainer, toast} from "react-toastify";
import axios from '../utils/axios';

function GetCredentials() {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    var [phone, setPhone] = useState("");
    var [name, setName] = useState("");
    var [email, setEmail] = useState("");


    const handleSubmit = () => {
        if (name === '') {
            toast('Business Name required!')
            return;
        } else if (email === '') {
            toast('Email required!')
            return;
        } else if (!email.includes('@')) {
            toast('Please provide a valid email!')
            return;
        } else if (phone === '') {
            toast('Phone number required!')
            return;
        }
        const json = {
            businessName: name,
            email: email,
            phone: phone,
        };

        axios.post('/credentialsRequest/registerCredentialsRequest', json)
            .then(async (res) => {
                console.log(res);
                if (res.data.Result === false) {
                    toast('No Business registered against this name.');
                } else {
                    await toast('Request Sent to Admin - If Approved you will receive credentials on the email provided.');
                }
                setShow(false);
            })
            .catch((error) => {
                console.log(error);
            })
    };

    const handleInput = (e) => {
        // this is where we'll call the phoneNumberFormatter function
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        // we'll set the input value using our setInputValue
        setPhone(formattedPhoneNumber);
    };

    function formatPhoneNumber(value) {
        // if input value is falsy e.g. if the user deletes the input, then just return
        if (!value) return value;
        // clean the input for any non-digit values.
        const phoneNumber = value.replace(/[^\d]/g, "");
        // phoneNumberLength is used to know when to apply our formatting for the phone number
        const phoneNumberLength = phoneNumber.length;
        // we need to return the value with no formatting if it's less than four digits
        // this is to avoid weird behavior that occurs if you  format the area code to early
        if (phoneNumberLength < 4) return phoneNumber;
        // if phoneNumberLength is greater than 4 and less the 7 we start to return
        // the formatted number
        if (phoneNumberLength < 7) {
            return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
        }
        // finally, if the phoneNumberLength is greater than seven, we add the last
        // bit of formatting and return it.
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
            3,
            6
        )}-${phoneNumber.slice(6, 10)}`;
    }

    return (
        <>
            <ToastContainer/>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
            </div>
            <Button className='btn btn-danger w-100' onClick={handleShow}>
                Get your Credentials
            </Button>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Get your Credentials</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Enter your Business Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Business Name"
                                autoFocus
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                            <Form.Label>Your Email Address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="example@gmail.com"
                                autoFocus
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Form.Label>Enter your Phone Number</Form.Label>
                            <Form.Control
                                type="phone"
                                placeholder="(123) 456-7890"
                                autoFocus
                                onChange={(e) => handleInput(e)}
                                value={phone}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Request Credentials
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default GetCredentials;